import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useData } from './DataProvider'
import { Button } from '@mui/joy'
import ContactUsLink from './ContactUsLink'
import { SpinnerWhite } from '../../shared/Spinner'
import useTranslation from '../../shared/TranslationProvider'

const AccountServices = () => {
  const { isLoading, setIsLoading, getApi } = useData()
  const [servicesText, setServicesText] = useState({})
  const { t } = useTranslation()
  const headingRef = useRef(null)

  const navigateNext = () => {
    setIsLoading(true)
    window.location.href = servicesText.linkPath
  }

  const getServicesText = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await getApi().get('/license_added/new')
      if (response.data) {
        setServicesText(response.data)
      }
    } catch (error) {
      console.error(error)
      window.location.href = '/'
    } finally {
      setIsLoading(false)
    }
  }, [setServicesText, getApi, setIsLoading])

  useEffect(() => {
    if (!Object.keys(servicesText).length) {
      getServicesText()
    }
  }, [servicesText, getServicesText])

  useEffect(() => {
    if (servicesText.title && headingRef.current) {
      headingRef.current.focus()
    }
  }, [servicesText.title])

  if (isLoading && !Object.keys(servicesText).length) {
    return (
      <div
        className="flex min-h-[200px] items-center justify-center"
        role="status"
        aria-live="polite"
      >
        <span className="sr-only">{t('AccountServices.loading')}</span>
        <SpinnerWhite show={true} />
      </div>
    )
  }

  return (
    <>
      <h1
        ref={headingRef}
        tabIndex={-1}
        className="outline-none focus:outline-none"
      >
        {servicesText.title}
      </h1>
      <p className="mt-10">{servicesText.greeting}</p>
      <p className="mt-8">{servicesText.p1}</p>
      <p className="my-8">{servicesText.p2}</p>
      <Button
        className="submit-button btn"
        size="lg"
        fullWidth
        onClick={navigateNext}
        disabled={isLoading}
      >
        {servicesText.linkText}
      </Button>
      <div className="mt-6">
        <ContactUsLink />
      </div>
    </>
  )
}

export default AccountServices
